import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSkills,
  addSkill as addLang,
  updateSkill as updateLang,
  deleteSkill as deleteLang,
} from "../../services/skillService";
import { toast } from "react-toastify";

const initialState = {
  skills: [],
  status: "idle", // "idle" | "loading" | "succeeded" | "failed"
  error: null,
};

// Fetch all skills
export const fetchSkills = createAsyncThunk(
  "skills/fetchSkills",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSkills();
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Add a new skill
export const addSkill = createAsyncThunk(
  "skills/addSkill",
  async (skill, { rejectWithValue }) => {
    try {
      const response = await addLang(skill);
      toast.success(response.message || "Data added successfully!");
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Update a skill
export const updateSkill = createAsyncThunk(
  "skills/updateSkill",
  async ({ id, skill }, { rejectWithValue }) => {
    try {
      const response = await updateLang(id, skill);
      toast.success(response.message || "Data updated successfully!");
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Delete a skill
export const deleteSkill = createAsyncThunk(
  "skills/deleteSkill",
  async (id, { rejectWithValue }) => {
    try {
      let response = await deleteLang(id);
     toast.success(response.message || "Data deleted successfully!");
      return id;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

const skillSlice = createSlice({
  name: "skills",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Skills
      .addCase(fetchSkills.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSkills.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.skills = action.payload.data;
      })
      .addCase(fetchSkills.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Add Skill
      .addCase(addSkill.fulfilled, (state, action) => {
        state.skills.unshift(action.payload.data); 
      })

      // Update Skill
      .addCase(updateSkill.fulfilled, (state, action) => {
        const updatedSkill = action.payload.data;

        // Ensure `state.skills` exists and is an array
        if (!Array.isArray(state.skills)) {
            return;
        }
        const index = state.skills.findIndex((lang) =>{
         return lang._id === updatedSkill._id
        });
        if (index !== -1) {
          state.skills[index] = { ...state.skills[index], ...updatedSkill };
        }
      })

      // Delete Skill
      .addCase(deleteSkill.fulfilled, (state, action) => {
        const deletedId = action.payload;
        state.skills = state.skills.filter((lang) => lang._id !== deletedId);
      });
  },
});

export const { clearError } = skillSlice.actions;
export default skillSlice.reducer;
